export const CodeType = Object.freeze({
    confirming: Symbol('confirming'),

    /**
     * This code is dedicated for business partners. They are using it
     * to create a new account for the client. The account will be
     * automatically associated to the partner account.
     */
    customer_acquisition: Symbol('customer_acquisition'),

    promotional: Symbol('promotional'),
});

/**
 * Results of this method can be used in <v-select> fields.
 */
export function getItems(value = 'value', text = 'text') {
    let items = [];
    const types = Object.getOwnPropertyNames(CodeType);

    for (const type of types) {
        items.push({[value]: type, [text]: getTypeText(type)});
    }

    return items;
}

export function getTypeText(status) {
    return {
        [CodeType.confirming]: 'Potwierdzający',
        [CodeType.customer_acquisition]: 'Pozyskiwanie klientów',
        [CodeType.promotional]: 'Promocyjny',
    }[CodeType[status]];
}
